<template>
  <svg
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#4f2b1b">
      <path
        d="m15 30a15 15 0 1 1 13.82-9.16 15 15 0 0 1 -8 8 15 15 0 0 1 -5.82 1.16zm0-28.43a13.38 13.38 0 0 0 -5.23 1.05 13.49 13.49 0 0 0 -7.15 7.15 13.55 13.55 0 0 0 0 10.46 13.49 13.49 0 0 0 7.15 7.15 13.55 13.55 0 0 0 10.46 0 13.49 13.49 0 0 0 7.15-7.15 13.55 13.55 0 0 0 0-10.46 13.49 13.49 0 0 0 -7.15-7.15 13.38 13.38 0 0 0 -5.23-1.05z"
      />
      <path
        d="m20.44 11.77 2.23-3.94.5-.81.1-.2-1.92 1.11a8.2 8.2 0 0 0 -2-2.73c-.81-.4-6.88-.3-7.18-.3h-.31c-1.13.1-2.14 1.92-3.15 3.74a4.36 4.36 0 0 1 -.51 1l.21.3c.8.51 4.14 2.43 4.14 2.43h.1l2.53-4.65.1-.3a30.3 30.3 0 0 1 1.62 3.13l-2 1.21z"
      />
      <path
        d="m25.47 16.78c.21-1.07-.55-2.39-1.39-3.79-.3-.41-.71-.91-1-1.42l-.3-.1c-.81.41-4.15 2.43-4.15 2.43h-.1l2.93 4.85a28.93 28.93 0 0 1 -3.44-.2v-2.33l-2.83 4.86 2.94 4.85v-.3l-.13-1.92c.81 0 2.74 0 3.34-.4.1 0 .2-.11.31-.21.91-.81 3.13-4.85 3.64-5.76 0 0 .05-.11.08-.2s.08-.27.1-.36z"
      />
      <path d="m10 16c.1-.1.21-.3.31-.4a1.39 1.39 0 0 0 -.31.4z" />
      <path
        d="m8.61 18.35c.5-.91 1.72-2.73 1.72-2.73l2 1.11-2.81-4.85-5.67.12 1.93 1.11a11.51 11.51 0 0 0 -1.32 3.13c0 .92 3.24 6.17 3.34 6.38s.1.2.2.2c.51.71 1.82.81 3.24.81a7.18 7.18 0 0 0 1.51-.1h1.25l.2-.2c-.1-1-.1-4.86-.2-5z"
      />
    </g>
  </svg>
</template>
